import {
  SET_PROGRAM_CBTN_USERNAME,
  SET_PROGRAM_EVALUATION_DATA_SCHEMA,
  SET_USER,
  UPDATE_PREFERENCES,
} from '../actions/user';
import User from '../../types/User';
import { ProgramEvaluationSchema } from '../../types/Evaluation';

export interface UserState extends User {
  programEvaluationDataSchema?: ProgramEvaluationSchema;
}

const INITIAL_STATE:UserState = {} as UserState;

export function getUserInitialState () {
  return INITIAL_STATE;
}

export default function userReducer (state = INITIAL_STATE, action?:any) {
  switch (action.type) {
    case SET_USER:
      return action.user;
    case UPDATE_PREFERENCES:
      return {
        ...state,
        preferences: action.preferences
      };
    case SET_PROGRAM_CBTN_USERNAME:
      return {
        ...state,
        programCbtnUsername: action.programCbtnUsername,
      };
    case SET_PROGRAM_EVALUATION_DATA_SCHEMA:
      return {
        ...state,
        programEvaluationDataSchema: action.programEvaluationDataSchema,
      };
    default:
      return state;
  }
};
